import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

var NAV_CONTENT_CLASS = "content-wrapper";
var NAV_CONTENT_SECONDARY_CLASS = "content-wrapper-with-side-nav";

var NavigationContent = function (_PureComponent) {
  _inherits(NavigationContent, _PureComponent);

  function NavigationContent(props) {
    _classCallCheck(this, NavigationContent);

    return _possibleConstructorReturn(this, (NavigationContent.__proto__ || Object.getPrototypeOf(NavigationContent)).call(this, props));
  }

  _createClass(NavigationContent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          hasSecondaryNav = _props.hasSecondaryNav;


      var classNames = [NAV_CONTENT_CLASS];
      if (hasSecondaryNav) {
        classNames.push(NAV_CONTENT_SECONDARY_CLASS);
      }
      var className = classNames.join(' ');

      return React.createElement(
        'div',
        { className: className },
        children
      );
    }
  }]);

  return NavigationContent;
}(PureComponent);

NavigationContent.propTypes = {
  hasSecondaryNav: PropTypes.bool
};
export default NavigationContent;